var _rect, _g, _path, _path2, _g2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOtherInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-35 -14C-35 -20.6274 -29.6274 -26 -23 -26H143C149.627 -26 155 -20.6274 155 -14V161.231C155 167.858 149.627 173.231 143 173.231H-23C-29.6274 173.231 -35 167.858 -35 161.231V-14Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 53.5C112 82.4949 88.4949 106 59.5 106C30.5051 106 7 82.4949 7 53.5C7 24.5051 30.5051 1 59.5 1C88.4949 1 112 24.5051 112 53.5Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 105,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53.5C112 82.4949 88.4949 106 59.5 106C30.5051 106 7 82.4949 7 53.5C7 24.5051 30.5051 1 59.5 1C88.4949 1 112 24.5051 112 53.5Z",
    fill: "#D6E8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 29,
    width: 43.3969,
    height: 55.4515,
    rx: 2,
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0283,
    y: 45.4155,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0283,
    y: 41.2319,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0283,
    y: 37.1548,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0283,
    y: 53.251,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0273,
    y: 57.4702,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0283,
    y: 61.6187,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.3516,
    y: 18,
    width: 43.3969,
    height: 55.4515,
    rx: 2,
    transform: "rotate(15 54.3516 18)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9248,
    y: 35.4165,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 55.9248 35.4165)",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.0078,
    y: 31.3755,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 57.0078 31.3755)",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0635,
    y: 27.437,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 58.0635 27.437)",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8975,
    y: 42.9849,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 53.8975 42.9849)",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.8057,
    y: 47.0601,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 52.8057 47.0601)",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7314,
    y: 51.0674,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 51.7314 51.0674)",
    fill: "#FDBD90"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 6.27543C0.625 5.93148 0.916786 5.64485 1.2892 5.6341C1.40437 5.63051 12.4884 5.25789 18.9845 0.163032C19.2532 -0.0519407 19.6487 -0.0555235 19.9174 0.15945L19.9213 0.163032C26.4173 5.26148 37.4745 5.6341 37.5858 5.63768C37.9544 5.64843 38.25 5.93148 38.25 6.27902V6.32918C38.25 15.1861 36.6989 27.5685 29.0511 36.2427C24.4209 41.4952 19.8329 42.8782 19.6371 42.9355L19.4298 43L19.2148 42.9355C19.019 42.8782 14.4579 41.4952 9.82777 36.2427C2.17607 27.5649 0.625 15.1861 0.625 6.32559V6.27543Z",
    fill: "#E62645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1985 21.0833L17.3649 25.0842C17.7522 25.4561 18.364 25.4557 18.7509 25.0834L27.8022 16.373C28.4562 15.7436 28.4562 14.6969 27.8022 14.0675C27.1828 13.4714 26.203 13.4714 25.5836 14.0675L18.055 21.3126L15.4146 18.776C14.7945 18.1803 13.8144 18.1814 13.1956 18.7786C12.5428 19.4086 12.5441 20.4549 13.1985 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_832",
    x: -55,
    y: -42,
    width: 230,
    height: 239.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_832",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOtherInsurance);
export default __webpack_public_path__ + "static/media/imgOtherInsurance.61691b737a6a500c1fb422354dbd5485.svg";
export { ForwardRef as ReactComponent };